import { useEffect } from "react";
import Brochure from "./Brochure";
import CourseOfferings from "./CourseOfferings";
import Courses from "./Courses";
import FacultyCarousel from "./FacultyCarousel";
import FeaturesSection from "./FeaturesSection";
import HeroRegistration from "./HeroRegistration";
import OutcomePowerhouse from "./Outcomepowerhouse";
import RecentContent from "./RecentContent";
import RequestCall from "./RequestCall";
// Import Swiper styles
import 'swiper/css';
import TraineesCarousel from "./TraineesCarousel";
// import { verifyUser } from "../../PrivateRoute";
export default function Home() {


  return (
    <main>
      <HeroRegistration />
      {/* <Brochure /> */}
      <FeaturesSection />
      <CourseOfferings />
      <OutcomePowerhouse />
      <FacultyCarousel />
      {/* <Courses /> */}
      <RequestCall />
      <TraineesCarousel />
      <RecentContent />
    </main>
  );
}
